export const LogoMark = ({ size = 40, className = "" }) => (
  <img
    src="/wizard-icon.png"
    width={size}
    height={size}
    alt="dealzauber Zauberer Logo"
    className={`rounded-[11px] object-cover shadow-sm ${className}`}
    style={{ width: size, height: size }}
  />
);

export const Logo = ({ markSize = 38, className = "", showTagline = true }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <LogoMark size={markSize} className="shadow-sm rounded-[11px]" />
    <div className="leading-none">
      <p className="font-heading font-extrabold text-lg tracking-tight">
        <span className="text-[#1D1D1F]">deal</span>
        <span className="ai-gradient-text">zauber</span>
      </p>
      {showTagline && (
        <p className="text-[11px] text-[#86868B] mt-1 tracking-wide">dealzauber.de</p>
      )}
    </div>
  </div>
);

export default Logo;
